import React from "react";
import image1 from "../../assets/images/livasa-about/aboutImg1.jpg";
import image2 from "../../assets/images/Services/white-label3.jpg";
import image3 from "../../assets/images/livasa-about/our-products.jpg";
import "./AboutSection1.css";
import AboutSectionSubsection1 from "./AboutSectionSubsection1";
export default function AboutSection1() {
  const aboutContent = [
    {
      image: image1,
      title: "Our Purpose",
      bodycopy:
        "Empowering sustainable farming and biodiversity through Eco-Bee technology and services.",
    },
    {
      rowreverse: "true",
      image: image2,
      title: "Our Services",
      bodycopy:
        "ApisChain is dedicated to offer top-quality sustainable products and services, with a strong focus on honeybees. We provide following services for our partners:",
      bodycopy2: "true",
    },
    {
      image: image3,
      title: "Our Brands",
      bodycopy:
        "ApisChain offers a wide range of honey and honey-based products that cater to diverse preferences and needs.",
        bodycopy3: "true",
    },
  ];
  return (
    <>
      {aboutContent.map((e, index) => {
        return (
          <AboutSectionSubsection1
            key={index}
            src={e.image}
            bodycopy={e.bodycopy}
            title={e.title}
            rowreverse={e.rowreverse}
            bodycopy2={e.bodycopy2}
            bodycopy3={e.bodycopy3}
          />
        );
      })}
    </>
  );
}
